"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notifications = function Notifications() {
  return _react2.default.createElement(
    "g",
    { id: "notifications" },
    _react2.default.createElement("path", {
      d: "M249.582651,500.234592 C277.796041,500.153686 300.647409,477.302319 300.728314,449.088929 L198.436989,449.088929 C198.432645,462.654933 203.819796,475.666556 213.41241,485.25917 C223.005024,494.851785 236.016647,500.238935 249.582651,500.234592 Z M403.01964,346.797603 L403.01964,218.933446 C403.01964,140.422808 361.080196,74.7026771 287.94599,57.3131518 L287.94599,39.9236264 C288.148112,26.0856618 280.881408,13.2114785 268.929931,6.23349077 C256.978454,-0.744496923 242.195032,-0.744496923 230.243555,6.23349077 C218.292078,13.2114785 211.025374,26.0856618 211.227496,39.9236264 L211.227496,57.3131518 C137.831424,74.7026771 96.1456628,140.169126 96.1456628,218.933446 L96.1456628,346.797603 L45,397.943266 L45,423.516098 L454.165303,423.516098 L454.165303,397.943266 L403.01964,346.797603 Z",
      id: "Shape"
    })
  );
};

exports.default = Notifications;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Notifications.js
// module id = 2971
// module chunks = 4